import { ChartType, type TChartType } from '@dbl/core/chart';
import type { IChartCalculationRequestConfig } from '@dbl/services/common/chartCalculationCore';

/**
 * 报表页各图表类型对应的计算接口配置（路径与请求差异点）。
 * URL 保持与存量 calculationChart 实现一致。
 */
export const dashboardChartConfigByType: Partial<
Record<TChartType, IChartCalculationRequestConfig>
> = {
  [ChartType.Table]: {
    url: '/api/v2/datalab/dashboard_chart_table',
  },
  [ChartType.Pie]: {
    url: '/api/v1/datalab/getChartAnalysis', // 旧接口, 后续看后端情况进行修改.
  },
  [ChartType.Bar]: {
    url: '/api/v2/datalab/dashboard_chart_bar',
  },
  [ChartType.HorizontalBarChart]: {
    url: '/api/v2/datalab/dashboard_chart_horizontal_bar',
  },
  [ChartType.StackBar]: {
    url: '/api/v2/datalab/dashboard_chart_stack_bar',
  },
  [ChartType.PercentStackBar]: {
    url: '/api/v2/datalab/dashboard_chart_percent_stack_bar',
  },
  [ChartType.PercentLine]: {
    url: '/api/v2/datalab/dashboard_chart_percent_line',
  },
  [ChartType.Line]: {
    url: '/api/v2/datalab/dashboard_chart_line',
  },
  [ChartType.MixedChart]: {
    url: '/api/v2/datalab/dashboard_chart_mixed',
  },
  [ChartType.BigNumber]: {
    url: 'api/v2/datalab/dashboard_chart_big_number',
  },
  [ChartType.Trend]: {
    url: '/api/v1/datalab/getChartAnalysis', // 旧接口, 后续看后端情况进行修改.
  },
  [ChartType.DimNumberTrend]: {
    url: '/api/v1/datalab/getChartAnalysisV2', // 旧接口, 后续看后端情况进行修改.
  },
  [ChartType.Map]: {
    url: '/api/v2/datalab/dashboard_chart_map',
  },
  [ChartType.WordCloud]: {
    url: 'api/v2/datalab/dashboard_chart_word_cloud',
  },
  [ChartType.EventLine]: {
    url: 'api/v2/datalab/dashboard_chart_event_line',
  },
};
